import gql from 'graphql-tag';

export const deleteCompany = gql`
  mutation deleteCompany($id: String!) {
    deleteCompany(id: $id)
  }
`;
